import React from 'react';
import { WorkspaceActionHeader } from './WorkspaceActionHeader';
import type { WorkspaceMode } from '@auw/workspace-utils';

interface WorkspaceHeaderProps {
  mode: WorkspaceMode;
  pageSidebarOpen: boolean;
}

export const WorkspaceHeader: React.FC<WorkspaceHeaderProps> = (props) => {
  return <WorkspaceActionHeader {...props} />;
};
